import React from "react";
import { Card, CardBody } from "reactstrap";

const DashboardCards = () => {
    const cards = [
        { title: "Today's Tests", value: 12 },
        { title: "Avg FAT", value: "4.2%" },
        { title: "Avg SNF", value: "8.8%" },
        { title: "Total Litres", value: 350 }
    ];

    return (
        <div className="row">
            {cards.map((item) => (
                <div className="col-md-3 mb-3" key={item.title}>
                    <Card className="shadow-sm border-0">
                        <CardBody>
                            <h6 className="text-muted">{item.title}</h6>
                            <h3 className="font-bold">{item.value}</h3>
                        </CardBody>
                    </Card>
                </div>
            ))}
        </div>
    );
};

export default DashboardCards;
